module.exports = __webpack_public_path__ + "img/CM-MC-25-Hyundai-Established.831f042e.jpg";